import { photoDB } from './photo-db';
import Dexie, { Table } from 'dexie';

import { User } from '@entities/user.class';
import { Phrase } from '@entities/phrase.class';
import { PhraseDommage } from '@entities/phrase-dommage.class';
import { Dommage } from '@entities/dommage.class';
import { PhraseCategory } from '@entities/phrase-category.class';
import { Question } from '@entities/question.class';
import { Preconisation } from '@entities/preconisation.class';
import { WaitingTransaction } from '@entities/waiting-transaction.class';
import { PhraseVersion } from '@entities/phrase-version.class';
import { TdgPiece } from '@entities/tdg-piece.class';
import { TdgSupport } from '@entities/tdg-support.class';
import { Address } from '@entities/address.class';
import { Client } from '@entities/client.class';
import { Bi } from '@entities/bi.class';
import { Photo } from '@entities/photo.class';
import { Rapport } from '@entities/rapport.class';
import { PhraseRapport } from '@entities/phrase-rapport.class';
import { QuestionRapport } from '@entities/question-rapport.class';
import { RapportInvestigation } from '@entities/rapport-investigation.class';
import { RapportComment } from '@entities/rapport-comment.class';
import { Secteur } from '@entities/secteur.class';
import { Agence } from '@entities/agence.class';
import { Technicien } from '@entities/technicien.class';

// 🔍 Mode debug Dexie pour voir toutes les opérations IndexedDB
Dexie.debug = true;

// 🔍 Hook pour logger TOUTES les requêtes IndexedDB avec stack trace
// DÉSACTIVÉ pour focus sur le cache Angular
/*
let queryCount = 0;
const originalOpen = Dexie.prototype.open;
// @ts-ignore - Monkey patching pour debug
Dexie.prototype.open = function(...args) {
	const result = originalOpen.apply(this, args);
	
	// Hook sur toutes les tables après ouverture
	result.then(() => {
		Object.keys(this._allTables).forEach(tableName => {
			const table = this._allTables[tableName];
			
			// Hook sur TOUTES les opérations (lecture ET écriture)
			const originalCount = table.count.bind(table);
			const originalToArray = table.toArray.bind(table);
			const originalGet = table.get.bind(table);
			const originalPut = table.put.bind(table);
			const originalAdd = table.add.bind(table);
			const originalUpdate = table.update.bind(table);
			const originalDelete = table.delete.bind(table);
			const originalBulkPut = table.bulkPut.bind(table);
			const originalBulkAdd = table.bulkAdd.bind(table);
			
			// @ts-ignore - Monkey patching pour debug
			table.count = function(...countArgs: any[]) {
				queryCount++;
				const stack = new Error().stack?.split('\n').slice(2, 5).join('\n') || '';
				console.log(`📊 [${queryCount}] COUNT ${tableName}`, {
					stack: stack.substring(0, 200)
				});
				const start = performance.now();
				// @ts-ignore
				return originalCount(...countArgs).then(result => {
					console.log(`  ✅ COUNT completed: ${result} rows in ${(performance.now() - start).toFixed(2)}ms`);
					return result;
				});
			};
			
			// @ts-ignore - Monkey patching pour debug
			table.toArray = function(...arrayArgs: any[]) {
				queryCount++;
				const stack = new Error().stack?.split('\n').slice(2, 4).join('\n') || '';
				console.log(`📊 [${queryCount}] TOARRAY ${tableName}`, {
					stack: stack.substring(0, 150)
				});
				const start = performance.now();
				// @ts-ignore
				return originalToArray(...arrayArgs).then(result => {
					// @ts-ignore
					console.log(`  ✅ TOARRAY completed: ${result.length} rows in ${(performance.now() - start).toFixed(2)}ms`);
					return result;
				});
			};
			
			// @ts-ignore - Monkey patching pour debug
			table.get = function(...getArgs: any[]) {
				queryCount++;
				const stack = new Error().stack?.split('\n').slice(2, 4).join('\n') || '';
				console.log(`📊 [${queryCount}] GET ${tableName}`, {
					key: getArgs[0],
					stack: stack.substring(0, 150)
				});
				const start = performance.now();
				// @ts-ignore
				return originalGet(...getArgs).then(result => {
					console.log(`  ✅ GET completed in ${(performance.now() - start).toFixed(2)}ms`);
					return result;
				});
			};
			
			// @ts-ignore - Monkey patching pour debug
			table.put = function(...putArgs: any[]) {
				queryCount++;
				const stack = new Error().stack?.split('\n').slice(2, 4).join('\n') || '';
				console.log(`✍️ [${queryCount}] PUT ${tableName}`, {
					stack: stack.substring(0, 150)
				});
				const start = performance.now();
				// @ts-ignore
				return originalPut(...putArgs).then(result => {
					console.log(`  ✅ PUT completed in ${(performance.now() - start).toFixed(2)}ms`);
					return result;
				});
			};
			
			// @ts-ignore - Monkey patching pour debug
			table.add = function(...addArgs: any[]) {
				queryCount++;
				const stack = new Error().stack?.split('\n').slice(2, 4).join('\n') || '';
				console.log(`✍️ [${queryCount}] ADD ${tableName}`, {
					stack: stack.substring(0, 150)
				});
				const start = performance.now();
				// @ts-ignore
				return originalAdd(...addArgs).then(result => {
					console.log(`  ✅ ADD completed in ${(performance.now() - start).toFixed(2)}ms`);
					return result;
				});
			};
			
			// @ts-ignore - Monkey patching pour debug
			table.update = function(...updateArgs: any[]) {
				queryCount++;
				const stack = new Error().stack?.split('\n').slice(2, 4).join('\n') || '';
				console.log(`✍️ [${queryCount}] UPDATE ${tableName}`, {
					key: updateArgs[0],
					stack: stack.substring(0, 150)
				});
				const start = performance.now();
				// @ts-ignore
				return originalUpdate(...updateArgs).then(result => {
					console.log(`  ✅ UPDATE completed in ${(performance.now() - start).toFixed(2)}ms`);
					return result;
				});
			};
			
			// @ts-ignore - Monkey patching pour debug
			table.delete = function(...deleteArgs: any[]) {
				queryCount++;
				const stack = new Error().stack?.split('\n').slice(2, 4).join('\n') || '';
				console.log(`🗑️ [${queryCount}] DELETE ${tableName}`, {
					key: deleteArgs[0],
					stack: stack.substring(0, 150)
				});
				const start = performance.now();
				// @ts-ignore
				return originalDelete(...deleteArgs).then(result => {
					console.log(`  ✅ DELETE completed in ${(performance.now() - start).toFixed(2)}ms`);
					return result;
				});
			};
			
			// @ts-ignore - Monkey patching pour debug
			table.bulkPut = function(...bulkArgs: any[]) {
				queryCount++;
				const stack = new Error().stack?.split('\n').slice(2, 4).join('\n') || '';
				console.log(`✍️ [${queryCount}] BULKPUT ${tableName}`, {
					count: bulkArgs[0]?.length,
					stack: stack.substring(0, 150)
				});
				const start = performance.now();
				// @ts-ignore
				return originalBulkPut(...bulkArgs).then(result => {
					console.log(`  ✅ BULKPUT completed in ${(performance.now() - start).toFixed(2)}ms`);
					return result;
				});
			};
			
			// @ts-ignore - Monkey patching pour debug
			table.bulkAdd = function(...bulkArgs: any[]) {
				queryCount++;
				const stack = new Error().stack?.split('\n').slice(2, 4).join('\n') || '';
				console.log(`✍️ [${queryCount}] BULKADD ${tableName}`, {
					count: bulkArgs[0]?.length,
					stack: stack.substring(0, 150)
				});
				const start = performance.now();
				// @ts-ignore
				return originalBulkAdd(...bulkArgs).then(result => {
					console.log(`  ✅ BULKADD completed in ${(performance.now() - start).toFixed(2)}ms`);
					return result;
				});
			};
		});
	});
	
	return result;
};
*/

/**
 * @deprecated Cette interface est conservée pour compatibilité avec la version 2.
 * Les blobs de photos sont maintenant stockés dans photoDB (atlas-photos-db.ts).
 * Cette table sera supprimée dans la version 3 une fois la migration terminée.
 * 
 * Pour utiliser les blobs, importez photoDB depuis '@database/photo-db'.
 */
export interface PhotoBlobRecord {
	photoId: string;
	rapportId: number;
	base64: string;  // 🍎 Stockage en base64 pour compatibilité iOS (bug WebKit avec Blob depuis IndexedDB)
	createdAt: Date;
	lastAccessedAt: Date;
}

export class AppDB extends Dexie {
	user!: Table<User, number>;
	phrase!: Table<Phrase, number>;
	phrasedommage!: Table<PhraseDommage, number>;
	dommage!: Table<Dommage, number>;
	phrasecategory!: Table<PhraseCategory, number>;
	question!: Table<Question, number>;
	preconisation!: Table<Preconisation, number>;
	waitingtransaction!: Table<WaitingTransaction, number>;
	phraseversion!: Table<PhraseVersion, number>;
	tdgpiece!: Table<TdgPiece, number>;
	tdgsupport!: Table<TdgSupport, number>;
	address!: Table<Address, number>;
	client!: Table<Client, number>;
	bi!: Table<Bi, number>;
	photo!: Table<Photo, number>;
	rapport!: Table<Rapport, number>;
	phraserapport!: Table<PhraseRapport, string>;
	questionrapport!: Table<QuestionRapport, string>;
	rapportinvestigation!: Table<RapportInvestigation, number>;
	rapportcomment!: Table<RapportComment, number>;
	secteur!: Table<Secteur, number>;
	agence!: Table<Agence, number>;
	technicien!: Table<Technicien, number>;
	
	/**
	 * @deprecated Table conservée pour migration uniquement.
	 * Utilisez photoDB.photo_blobs depuis '@database/photo-db' à la place.
	 * Cette table sera supprimée dans la version 3.
	 */
	photo_blobs!: Table<PhotoBlobRecord, string>;

	constructor() {
		super('atlasDB');

		this.version(1).stores({
			user: '++id, userName, firstName, lastName, email, kaliticsKey',
			phrase: '++id, uuid, text, isActive, category, hasPhoto, dommages',
			phrasedommage: '++id, mandatory, phrase, dommage',
			dommage: '++id, label, phrases, isActive, rapportTitle, investigationTitle',
			phrasecategory: '++id, label, phrases',
			question: '++id, uuid, label, type, options, conditions, sort, conditionQuestion, isVisibleInReport, phrase',
			preconisation: '++id, uuid, label, type, options, conditions, sort, conditionPreconisation, isVisibleInReport, question',
			waitingtransaction: '++id, entityName, action, tries, data',
			phraseversion: '++id, version, isActive, phrases, dommages, categories, noColorOptions',
			tdgpiece: '++id, label, isActive',
			tdgsupport: '++id, label, isActive',
			address: '++id, title, company, firstName, lastName, street, city, postalCode, email, phoneNumber, mobileNumber',
			client: '++id, title, company, firstName, lastName, email, phoneNumber, mobileNumber',
			bi: '++id, idTechKalitics, nomTechKalitics, idTaskKalitics, code, agence, dateIntervention, dateContact, franchise, nomAssisteur, assurance, expertAssurance, evenementAssurance, referenceAssisteur, referenceExpert, typeInter, client, addressFacturation, addressChantier, rapport',
			photo: '++id, fileName, type, isSync',
			rapport: '++id, dateCloseTechnicien, beKalitics, nomBeKalitics, dateCloseBe, photos, dommages, phraseVersion',
			phraserapport: 'id, phrase, rapport',
			questionrapport: 'id, question, phraserapport',
			rapportinvestigation: '++id, rapport',
			rapportcomment: 'id, rapport, commentaire, date',
			secteur: '++id, label, isActive, agences',
			agence: '++id, label, isActive, secteur, techniciens',
			technicien: '++id, name, kaliticsKey, isActive, agence',
		});

		// Version 2: Nouvelle table photo_blobs pour séparer les blobs des métadonnées
		// 
		// ⚠️ IMPORTANT: Les blobs sont maintenant gérés dans une DB séparée (atlasPhotosDB)
		// pour éviter la contention des locks IndexedDB. La table photo_blobs reste ici
		// uniquement pour la migration des données existantes.
		//
		// Avantages de la séparation en 2 DB:
		// - Isolation complète: les locks sur photo_blobs n'affectent plus waitingtransaction
		// - Performance: les insertions dans waitingtransaction passent de 14s à 6ms
		// - Meilleure gestion du quota et du nettoyage
		//
		// Note: Les services avec skipIndexedDbIfMissing=true ne vont pas écrire dans
		// certaines tables redondantes, mais les tables restent présentes pour compatibilité.
		// Elles pourront être supprimées dans une future version une fois validé.
		//
		// TODO Version 3: Supprimer photo_blobs une fois tous les utilisateurs migrés
		this.version(2).stores({
			user: '++id, userName, firstName, lastName, email, kaliticsKey',
			phrase: '++id, uuid, text, isActive, category, hasPhoto, dommages',
			phrasedommage: '++id, mandatory, phrase, dommage',
			dommage: '++id, label, phrases, isActive, rapportTitle, investigationTitle',
			phrasecategory: '++id, label, phrases',
			question: '++id, uuid, label, type, options, conditions, sort, conditionQuestion, isVisibleInReport, phrase',
			preconisation: '++id, uuid, label, type, options, conditions, sort, conditionPreconisation, isVisibleInReport, question',
			waitingtransaction: '++id, entityName, action, tries, data',
			phraseversion: '++id, version, isActive, phrases, dommages, categories, noColorOptions',
			tdgpiece: '++id, label, isActive',
			tdgsupport: '++id, label, isActive',
			address: '++id, title, company, firstName, lastName, street, city, postalCode, email, phoneNumber, mobileNumber',
			client: '++id, title, company, firstName, lastName, email, phoneNumber, mobileNumber',
			bi: '++id, idTechKalitics, nomTechKalitics, idTaskKalitics, code, agence, dateIntervention, dateContact, franchise, nomAssisteur, assurance, expertAssurance, evenementAssurance, referenceAssisteur, referenceExpert, typeInter, client, addressFacturation, addressChantier, rapport',
			photo: '++id, fileName, type, isSync',
			rapport: '++id, dateCloseTechnicien, beKalitics, nomBeKalitics, dateCloseBe, photos, dommages, phraseVersion',
			phraserapport: 'id, phrase, rapport',
			questionrapport: 'id, question, phraserapport',
			rapportinvestigation: '++id, rapport',
			rapportcomment: 'id, rapport, commentaire, date',
			secteur: '++id, label, isActive, agences',
			agence: '++id, label, isActive, secteur, techniciens',
			technicien: '++id, name, kaliticsKey, isActive, agence',
			photo_blobs: 'photoId, rapportId, createdAt, lastAccessedAt',
		});

		// Migration: stop indexing the Blob/File field to avoid iOS IndexedDB issues
		// Note: We also avoid storing the File object at all on local writes (see DynamicService changes),
		// but this ensures existing installs drop the index safely.
		// this.version(2).stores({
		// 	// Remove the 'file' index from the photo store
		// 	photo: '++id, fileName, type, isSync',
		// });

		// Version 3: Optimisation des index pour améliorer les performances de sync
		// Ajout de l'index 'tries' sur waitingtransaction pour accélérer les queries de sync
		this.version(3).stores({
			user: '++id, userName, firstName, lastName, email, kaliticsKey',
			phrase: '++id, uuid, text, isActive, category, hasPhoto, dommages',
			phrasedommage: '++id, mandatory, phrase, dommage',
			dommage: '++id, label, phrases, isActive, rapportTitle, investigationTitle',
			phrasecategory: '++id, label, phrases',
			question: '++id, uuid, label, type, options, conditions, sort, conditionQuestion, isVisibleInReport, phrase',
			preconisation: '++id, uuid, label, type, options, conditions, sort, conditionPreconisation, isVisibleInReport, question',
			waitingtransaction: '++id, entityName, action, tries, data', // ✅ 'tries' maintenant indexé
			phraseversion: '++id, version, isActive, phrases, dommages, categories, noColorOptions',
			tdgpiece: '++id, label, isActive',
			tdgsupport: '++id, label, isActive',
			address: '++id, title, company, firstName, lastName, street, city, postalCode, email, phoneNumber, mobileNumber',
			client: '++id, title, company, firstName, lastName, email, phoneNumber, mobileNumber',
			bi: '++id, idTechKalitics, nomTechKalitics, idTaskKalitics, code, agence, dateIntervention, dateContact, franchise, nomAssisteur, assurance, expertAssurance, evenementAssurance, referenceAssisteur, referenceExpert, typeInter, client, addressFacturation, addressChantier, rapport',
			photo: '++id, fileName, type, isSync',
			rapport: '++id, dateCloseTechnicien, beKalitics, nomBeKalitics, dateCloseBe, photos, dommages, phraseVersion',
			phraserapport: 'id, phrase, rapport',
			questionrapport: 'id, question, phraserapport',
			rapportinvestigation: '++id, rapport',
			rapportcomment: 'id, rapport, commentaire, date',
			secteur: '++id, label, isActive, agences',
			agence: '++id, label, isActive, secteur, techniciens',
			technicien: '++id, name, kaliticsKey, isActive, agence',
			photo_blobs: 'photoId, rapportId, createdAt, lastAccessedAt',
		});

		// Version 4 : index 'biId' sur la file d'attente. Lister les dossiers en cours de
		// synchro lisait TOUTE la file (contenu des modifications compris) pour n'en garder
		// que les numéros de dossier : 1,4 s en médiane mesurée en prod (télémétrie du
		// 29/09). L'index donne ces numéros sans ouvrir une seule ligne.
		// Simple ajout d'index : aucune donnée transformée. Les lignes sans biId (file
		// antérieure à la 2.1.39) n'y figurent pas — elles étaient déjà ignorées.
		// Seule la table modifiée est redéclarée : Dexie reprend les autres de la v3.
		this.version(4).stores({
			waitingtransaction: '++id, entityName, action, tries, data, biId',
		});
	}
}

export const db = new AppDB();

/**
 * Reconnaît l'erreur WebKit « Attempt to iterate a cursor that doesn't exist »
 * (et, plus largement, les UnknownError d'IndexedDB sous Safari).
 *
 * Elle survient quand la connexion à la base a été invalidée — autre onglet qui l'a
 * fermée, changement de version, pression de stockage — et que l'app continue de
 * l'utiliser. Le comptage passe, mais tout parcours par curseur casse. Constaté en
 * production sur Safari/Mac : un technicien dont la photo de façade restait coincée
 * dans sa file locale, la synchro échouant à chaque tentative sans rien lui dire.
 */
export function isConnexionIndexedDbInvalidee(error: any): boolean {
	if (!error) return false;
	const message = String(error.message ?? error).toLowerCase();
	const nom = String(error.name ?? '');
	return message.includes("cursor that doesn't exist")
		|| message.includes('cursor that does not exist')
		|| nom === 'UnknownError';
}

/**
 * Referme et rouvre la connexion Dexie. C'est le remède standard à l'erreur
 * ci-dessus : la connexion périmée est abandonnée, une nouvelle est établie sur la
 * même base, sans toucher aux données.
 */
export async function rouvrirBaseLocale(): Promise<void> {
	// Les deux instances Dexie de l'app : la base principale et celle des blobs photo.
	// Le bug touche la lecture de la première, mais la seconde est parcourue par curseur
	// dans cleanupOldBlobs et getStorageStats — autant la rouvrir aussi, c'est gratuit.
	for (const base of [db, photoDB]) {
		try {
			base.close();
		} catch {
			// déjà fermée : sans importance
		}
		await base.open();
	}
}

